import { createTheme } from 'xgimi-ui/theme';

export default createTheme({
  // TODO 自定义
});
